import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { SalesOrderResponseEntity } from 'src/entities/SalesOrder.response.entity';
import requestUtil from 'src/utils/request.util';
import updateQueryCache from 'src/utils/updateQueryCache';

import { queryKey } from './useSalesOrders.request';

export const useMutationSalesOrder = () => {
  const queryClient = useQueryClient();
  return {
    add: useMutation(
      (entity: SalesOrderResponseEntity) => axios.post('/api/v2/sales_orders', { data: requestUtil.convertKeysToSnakeCase(entity) }),
      {
        onSuccess: () => {
          // eslint-disable-next-line no-void
          void queryClient.invalidateQueries([queryKey]);
        },
        onError: (error: AxiosError<{data: string[]}>) => error.response.data
      }
    ),
    update: useMutation(
      (entity: SalesOrderResponseEntity) => axios.put(`/api/v2/sales_orders/${entity.id}`, { data: requestUtil.convertKeysToSnakeCase(entity) }),
      {
        onSuccess: (res: { data: SalesOrderResponseEntity }) => {
          updateQueryCache<SalesOrderResponseEntity & { id: number }>(queryClient, queryKey, res.data as SalesOrderResponseEntity & { id: number });
        },
        onError: (error: AxiosError<{data: string[]}>) => error.response?.data
      }
    ),
    delete: useMutation(
      (ids: number[]) => axios.delete('/api/v2/sales_orders/bulk', { data: { ids } }),
      {
        onSuccess: (_res) => {
          // eslint-disable-next-line no-void
          void queryClient.invalidateQueries([queryKey]);
        },
        onError: (error: AxiosError<{data: string[]}>) => error.response.data
      }
    ),
  };
};
